var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('form-filter-export', {
    on: {
      "onExport": _vm.exportPenerimaanBarang
    }
  }), _c('b-card', {
    attrs: {
      "title": "Daftar Penerimaan Barang"
    }
  }, [_c('b-row', {
    staticClass: "align-items-end mb-1"
  }, [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "2",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Per halaman",
      "label-for": "perPageSelect"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "perPageSelect",
      "size": "sm",
      "options": _vm.pageOptions
    },
    model: {
      value: _vm.perPage,
      callback: function callback($$v) {
        _vm.perPage = $$v;
      },
      expression: "perPage"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "2",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Status",
      "label-for": "statusSelect"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "statusSelect",
      "size": "sm",
      "options": _vm.statusOptions
    },
    model: {
      value: _vm.selectedStatus,
      callback: function callback($$v) {
        _vm.selectedStatus = $$v;
      },
      expression: "selectedStatus"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "4",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Cari",
      "label-for": "filterInput"
    }
  }, [_c('b-input-group', {
    attrs: {
      "size": "sm"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "filterInput",
      "type": "search",
      "placeholder": "Cari no. invoice / keterangan / tanggal..."
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.applySearch($event);
      }
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.clearSearch
    }
  }, [_vm._v(" Clear ")])], 1)], 1)], 1)], 1), _c('b-col', {
    staticClass: "my-1 d-flex justify-content-md-end align-items-end",
    attrs: {
      "md": "4",
      "sm": "6"
    }
  }, [_vm.allowCreate() && _vm.myGudang ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.add();
      }
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "PlusIcon"
    }
  }), _vm._v(" Penerimaan Barang ")], 1) : _vm._e()], 1)], 1), _vm.allowCreate() || _vm.allowUpdate() ? _c('b-modal', {
    attrs: {
      "id": "modal-penerimaan-barang",
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "centered": "",
      "title": "Form Penerimaan Barang",
      "size": "lg",
      "hide-footer": ""
    },
    model: {
      value: _vm.showModal,
      callback: function callback($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [_c('validation-observer', {
    ref: "form"
  }, [_c('div', {
    staticClass: "d-flex mb-1"
  }, [_c('feather-icon', {
    attrs: {
      "icon": "PackageIcon",
      "size": "19"
    }
  }), _c('h6', {
    staticClass: "ml-50 mb-0"
  }, [_vm._v("Penerimaan Barang")])], 1), _c('b-form', [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "12",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Pilih Nomor Invoice",
      "label-for": "v-jenis"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "jenis",
      "rules": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('b-form-radio-group', {
          staticClass: "inline-spacing",
          attrs: {
            "options": _vm.options,
            "value-field": "value",
            "text-field": "text",
            "disabled-field": "disabled"
          },
          model: {
            value: _vm.form.jenis,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "jenis", $$v);
            },
            expression: "form.jenis"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 2256560431)
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "No. Invoice",
      "label-for": "v-invoice"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "no_invoice",
      "rules": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-invoice",
            "placeholder": _vm.form.jenis == 0 ? 'Isi nomor invoice' : '',
            "disabled": _vm.form.jenis == 1,
            "state": errors.length > 0 ? false : null
          },
          model: {
            value: _vm.form.no_invoice,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "no_invoice", $$v);
            },
            expression: "form.no_invoice"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 1273671748)
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Gudang",
      "label-for": "gudang"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "gudang",
      "options": _vm.dataGudang,
      "disabled": _vm.user && _vm.user.level && _vm.user.level.id == 5
    },
    model: {
      value: _vm.form.gudang_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "gudang_id", $$v);
      },
      expression: "form.gudang_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tanggal Penerimaan",
      "label-for": "v-tanggal-terima"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "tanggal_penerimaan",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var errors = _ref3.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-tanggal-terima",
            "type": "date",
            "state": errors.length > 0 ? false : null
          },
          model: {
            value: _vm.form.tanggal_penerimaan,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "tanggal_penerimaan", $$v);
            },
            expression: "form.tanggal_penerimaan"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 2149389558)
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tanggal Invoice",
      "label-for": "v-tanggal-inv"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "tanggal_invoice",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var errors = _ref4.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-tanggal-inv",
            "type": "date",
            "state": errors.length > 0 ? false : null
          },
          model: {
            value: _vm.form.tanggal_invoice,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "tanggal_invoice", $$v);
            },
            expression: "form.tanggal_invoice"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 384703446)
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Keterangan (optional)",
      "label-for": "v-keterangan"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "v-keterangan",
      "placeholder": "Keterangan"
    },
    model: {
      value: _vm.form.keterangan,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "keterangan", $$v);
      },
      expression: "form.keterangan"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center mt-2"
  }, [_c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "size": "sm",
      "variant": "outline-secondary",
      "disabled": _vm.saving
    },
    on: {
      "click": function click($event) {
        _vm.showModal = false;
      }
    }
  }, [_vm._v(" Batal ")]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary",
      "disabled": _vm.saving
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.submit($event);
      }
    }
  }, [_vm.saving ? _c('b-spinner', {
    staticClass: "mr-50",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.saving ? "Menyimpan..." : "Simpan") + " ")], 1)], 1)], 1)], 1)], 1) : _vm._e(), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "small": "",
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.penerimaanBarangs,
      "fields": _vm.fields,
      "busy": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "cell(no)",
      fn: function fn(_ref5) {
        var index = _ref5.index;
        return [_vm._v(" " + _vm._s((_vm.currentPage - 1) * _vm.perPage + index + 1) + " ")];
      }
    }, {
      key: "cell(no_invoice)",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c('div', [_c('strong', [_vm._v(_vm._s(item.no_invoice || "-"))]), _c('small', {
          staticClass: "d-block text-muted"
        }, [_vm._v(" Tgl. Inv: " + _vm._s(_vm.humanDate(item.tanggal_invoice)) + " ")]), _c('small', {
          staticClass: "d-block text-muted"
        }, [_vm._v(" Tgl. Penerimaan: " + _vm._s(_vm.humanDate(item.tanggal_penerimaan)) + " ")])])];
      }
    }, {
      key: "cell(total_rincian)",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_vm._v(" " + _vm._s(item.total_rincian != null ? item.total_rincian : 0) + " ")];
      }
    }, {
      key: "cell(selesai)",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_c('b-badge', {
          attrs: {
            "variant": item.selesai == 1 ? 'success' : 'danger'
          }
        }, [_vm._v(" " + _vm._s(item.selesai == 1 ? "Selesai" : "Belum ditempatkan") + " ")])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(_ref9) {
        var item = _ref9.item;
        return [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('b-button', {
          staticClass: "mr-50",
          attrs: {
            "size": "sm",
            "variant": "warning"
          },
          on: {
            "click": function click($event) {
              return _vm.$router.push("/penerimaan-barang/view/".concat(item.id));
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "EyeIcon"
          }
        })], 1), _vm.canShowMoreActions(item) ? _c('b-dropdown', {
          attrs: {
            "size": "sm",
            "variant": "link",
            "toggle-class": "text-decoration-none p-0",
            "no-caret": "",
            "right": ""
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "MoreVerticalIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_vm.canEdit(item) ? _c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.$router.push("/penerimaan-barang/edit/".concat(item.id));
            }
          }
        }, [_vm._v(" Edit ")]) : _vm._e(), _vm.canDelete(item) ? _c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_vm._v(" Hapus ")]) : _vm._e()], 1) : _vm._e()], 1)];
      }
    }])
  })], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center",
      "size": "sm"
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }